export enum ClauseSubtype {
  RECRUITMENT_PROCESS,
  RECRUITMENT_PROCESSES,
  NO_PURPOSE,
  CURRENT_JOBS_COOPERATION,
  PRODUCTS_SERVICES_PROMOTIONS,
  PHOTOS,
  PERSONAL_DATA,
  COMMERCIAL_INFORMATION,
  SATISFACTION_RESEARCH,
  MOBILE_OFFERS,
  NO_SELECTION_NO_SIGNATURE,
  NO_SELECTION_SIGNATURE,
  NO_CLAUSE_DOCUMENT,
  OFFERS
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/clause/clause-subtype.enum.ts